import script from "./msMSelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./msMSelectBox.vue?vue&type=script&setup=true&lang=js"

import "./msMSelectBox.vue?vue&type=style&index=0&id=15b7a9fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b7a9fb"]])

export default __exports__